import { AngleDownIcon } from '../../../icons'

interface PaginationProps {
    total: number
    currentPage: number
    totalPages: number
    handlePageChange: (page: number) => void
}

const Pagination = ({ total, currentPage, totalPages, handlePageChange }: PaginationProps) => {
    return (
        <div className='flex justify-between items-center'>
            <div className='flex justify-end space-x-1'>
                <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className='px-3 py-2 cursor-pointer rounded-lg hover:bg-white hover:dark:bg-white/[0.03] text-gray-500 text-start text-theme-xs dark:text-gray-400'
                >
                    <AngleDownIcon className='rotate-90' />
                </button>
                {Array.from({ length: totalPages }, (_, i) => (
                    <button
                        key={i + 1}
                        onClick={() => handlePageChange(i + 1)}
                        className={`px-3 py-2 cursor-pointer rounded-lg text-start text-theme-xs font-semibold ${
                            currentPage === i + 1
                                ? 'bg-brand-500 text-white'
                                : 'hover:bg-white hover:dark:bg-white/[0.03] text-gray-500 dark:text-gray-400'
                        }`}
                    >
                        {i + 1}
                    </button>
                ))}
                <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className='px-3 py-2 cursor-pointer rounded-lg hover:bg-white hover:dark:bg-white/[0.03] text-gray-500 text-start text-theme-xs dark:text-gray-400'
                >
                    <AngleDownIcon className='-rotate-90' />
                </button>
            </div>

            <div className='text-theme-xs text-gray-500 dark:text-gray-400'>{`${total} ${
                total === 1 ? 'registro' : 'registros'
            }`}</div>
        </div>
    )
}

export default Pagination
